export default "__VITE_ASSET__pBd78qYX__"